import DebtWarehouseStatistic from "./DebtWarehouseStatistic";
import DebtWarehouseList from "./DebtWarehouseList";
const DebtWarehousePage = () => {
  return (
    <>
      <DebtWarehouseStatistic />
      <DebtWarehouseList />
    </>
  );
};

export { DebtWarehousePage };
